<template>
    <!-- TODO: CSS Class should be updated based on rogue name -->
    <!-- TODO: selectable is not a good condition to show or hide some address details. change them -->
    <component
        :is="selectable ? 'label' : 'div'"
        class="r-address-list__cart"
        :class="[{'is-selectable': selectable}]"
        :for="`r-address-list__cart-${address.id}`"
    >
        <header class="d-flex justify-content-between align-items-center mb-4">
            <div class="title typo-h6">
                <input
                    v-if="selectable"
                    :id="`r-address-list__cart-${address.id}`"
                    v-model="selectedAddress"
                    type="radio"
                    :value="address"
                    class="input"
                    name="addressGroup"
                    @change="onSelectedAddressChange"
                >
                {{ address.title || $t('dashboard.address.no_title') }}
            </div>
            <div>
                <y-button
                    icon="pen"
                    text
                    :color="selectable ? 'primary' : 'body'"
                    icon-size="tiny"
                    outline
                    class="ml-1"
                    @click.prevent="editAddress(address)"
                />
                <y-button
                    v-if="removable"
                    icon="trash"
                    text
                    color="danger"
                    icon-size="tiny"
                    outline
                    @click.prevent="removeAddress(address.id)"
                />
            </div>
        </header>
        <div
            v-if="address.address || address.city_name || address.province_name || address.neighbourhood_name"
            class="address-info d-flex justify-content-start align-items-start mt-2 mb-2"
        >
            <y-icon
                icon="mdi-map-marker-outline"
                library="mdi"
                size="small"
                color="body"
            />
            <p class="ma-0 typo-body-2">
                {{ digits(fullAddress, $i18n.locale) }}
            </p>
        </div>
        <div
            v-if="selectable && address.contact_name"
            class="contact-name d-flex justify-content-start align-items-center mt-2 mb-2"
        >
            <y-icon
                icon="mdi-account-outline"
                library="mdi"
                size="small"
                color="body"
            />
            <p class="ma-0 typo-body-2">
                {{ digits(address.contact_name, $i18n.locale) }}
            </p>
        </div>
        <div
            v-if="selectable && address.mobile"
            class="mobile d-flex justify-content-start align-items-center mt-2 mb-2"
        >
            <y-icon
                icon="mdi-phone"
                library="mdi"
                size="small"
                color="body"
            />
            <p class="ma-0 typo-body-2">
                {{ digits(address.mobile, $i18n.locale) }}
            </p>
        </div>
    </component>
</template>

<script>
    import { digits } from '@nodes/helpers/number';
    import { YIcon } from '@components';

    export default {
        name: 'AddressCardSimple',

        components: {
            YIcon,
        },

        props: {
            address   : Object,
            selectable: Boolean,
            removable : Boolean,
            selected  : Boolean,
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                selectedAddress: null,
            };
        },

        computed: {
            /**
             * Address with divisions
             * 
             * @returns {string}
             */
            fullAddress() {
                let ads = '';
                if (this.address.province_name) {
                    ads += `${this.address.province_name} - `;
                }
                if (this.address.city_name) {
                    ads += `${this.address.city_name} - `;
                }
                if (this.address.neighbourhood_name) {
                    ads += `${this.address.neighbourhood_name} - `;
                }
                if (this.address.address) {
                    ads += `${this.address.address}`;
                }
                if (this.address.postal_code) {
                    ads += ` / ${this.$t('dashboard.address.resource.postal_code')}: ${this.address.postal_code}`;
                }
                return ads;
            },
        },

        methods: {
            digits,

            /**
             * Emit Address to edit
             */
            onSelectedAddressChange() {
                this.$emit('selectedAddress', this.selectedAddress);
            },

            /**
             * Emit Address to edit
             * 
             * @param {object} address
             */
            editAddress(address) {
                this.$emit('edit', address);
            },

            /**
             * Remove address
             *
             * @param {string | number} id - ID of address item
             */
            removeAddress(id) {
                this.$emit('delete', id);
            },
        },
    };
</script>
